export default __webpack_public_path__ + "static/media/github.742264c5.svg";